import { DateTime } from "luxon";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { PPAInvoice } from "../../PPAInvoicePage.types";

export function getBillingPeriodColumn(): MRT_ColumnDef<PPAInvoice> {
  return {
    id: "billing_period",
    accessorFn: (row) => {
      const startDate = backendDateOrDateTimeToLuxonDateTime(
        row.billing_period.start
      ).toFormat(DATE_DISPLAY_FORMAT);
      const endDate = backendDateOrDateTimeToLuxonDateTime(
        row.billing_period.end
      ).toFormat(DATE_DISPLAY_FORMAT);

      return `${startDate} - ${endDate}`;
    },
    header: "Zeitraum",
    size: 200,
    filterVariant: "date-range",
    filterFn: (row, _columnId, filterValue: [string, string]) => {
      const period = row.original.billing_period;
      const [filterStart, filterEnd] = filterValue;

      if (!filterStart && !filterEnd) {
        return true;
      }

      const periodStart = backendDateOrDateTimeToLuxonDateTime(period.start);
      const periodEnd = backendDateOrDateTimeToLuxonDateTime(period.end);
      const filterStartDate = DateTime.fromISO(filterStart);
      const filterEndDate = DateTime.fromISO(filterEnd);

      let periodMatchesFilter = true;

      if (filterStart) {
        periodMatchesFilter =
          periodMatchesFilter &&
          periodEnd.valueOf() >= filterStartDate.valueOf();
      }

      if (filterEnd) {
        periodMatchesFilter =
          periodMatchesFilter &&
          periodStart.valueOf() <= filterEndDate.valueOf();
      }

      return periodMatchesFilter;
    },
    sortingFn: (rowA, rowB) => {
      const periodA = rowA.original.billing_period;
      const periodB = rowB.original.billing_period;

      const startA = backendDateOrDateTimeToLuxonDateTime(periodA.start);
      const startB = backendDateOrDateTimeToLuxonDateTime(periodB.start);

      return startA.valueOf() - startB.valueOf();
    }
  };
}
